import { useDispatch } from 'react-redux';

import { requestResetPasswordInternal } from '../../../api/party/party.actions';

import PasswordReset from '../../../components/screens/auth/password-reset/PasswordReset';

const InternalPasswordResetContainer = () => {
  const dispatch = useDispatch();
  const resetPassword = (input, resetSuccess) => {
    dispatch(requestResetPasswordInternal({ input, onSuccess: () => resetSuccess(true) }));
  };

  const navigateTo = {
    path: '/my-profile',
    name: 'My Profile',
  };

  return <PasswordReset resetPassword={resetPassword} navigateTo={navigateTo} internal={true} />;
};

export default InternalPasswordResetContainer;
